import { useEffect, useRef } from 'react';

export const useInterval = (callback: any, delay: number) => {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => {
      // @ts-ignore
      savedCallback.current();
    };

    if (delay !== null) {
      const interval = setInterval(tick, delay);

      return () => {
        clearInterval(interval);
      };
    }
  }, [callback, delay]);
};
